import { fetchJSON } from "./utils"

const BASE_URL = "/api/v2/token/quota"

export const fetchMetabaseUrl = async () => {
    return await fetchJSON(`${BASE_URL}/metabase`, null, null, "GET")
}
